import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useParams } from "react-router";
import { Spin, Button } from "antd";
import { useHistory } from "react-router-dom";
import * as taxCollectionActions from "../../../../actionCreators/TaxCollection";

import "./style/taxCollections.css";
import ProofDetailsForm from "./ProofDetailsForm";
import TaxCollectionForm from "./TaxCollectionForm";

const ViewProofOfPayment = ({
  taxCollection,
  getTaxCollection,
  user,
}) => {
  const [data, setData] = useState();
  const { id } = useParams();
  const history = useHistory();
  const [isInspector, setIsInspector] = React.useState(true);

  React.useEffect(() => {
    if (user) {
      setIsInspector(
        user.currentUser.data.user_roles.findIndex((e) => e.role_id == 1) >= 0
      );
    }
  }, [user]);

  React.useEffect(() => {
    getTaxCollection({ id: id });
  }, [id]);
  React.useEffect(() => {
    setData(taxCollection.data);
  }, [taxCollection]);

  return (
    <React.Fragment>
      {!data ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <div>
          <ProofDetailsForm data={data} isInspector={isInspector} />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="close-property-button"
              type="primary"
              onClick={() => history.push('/tax-collection/challans')}
            >
              Close
            </Button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = ({ taxCollection: { taxCollection }, user:{ user} }) => ({
  taxCollection,
  user,
});

const mapDispatchToProps = (dispatch) => ({
  getTaxCollection: bindActionCreators(
    taxCollectionActions.getTaxCollection,
    dispatch
  ),
  updateTaxCollection: bindActionCreators(
    taxCollectionActions.updateTaxCollection,
    dispatch
  ),
});

ViewProofOfPayment.propTypes = {
  taxCollection: PropTypes.object.isRequired,
  getTaxCollection: PropTypes.func.isRequired,
  updateTaxCollection: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewProofOfPayment);
